module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._l((_vm.card_data), function(item) {
    return [_c('el-col', {
      attrs: {
        "span": _vm.card_col_size
      }
    }, [_c('value-card', {
      staticClass: "value-card",
      attrs: {
        "cardname": item.key,
        "cardvalue": item.value,
        "linkto": item.scheme
      }
    })], 1)]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-38fbedd4"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/components/ValueCardGroup.vue
// module id = 253
// module chunks = 2